import { getReportLang } from "../../Web_General/js/generales/get_lang.js";
import { 
  getAllLangs,
  getLangCode,
  setLang,
  onLangChange
} from "../../Web_General/js/generales/globals.js";




import { login, cookiesConsent, openLoginRegisterPopup, openLegalPopup } from "../../Web_General/js/ui/ui.js";


// ⚡ [AÑADIDO] Registramos la referencia de login de inmediato aquí arriba para evitar retrasos de interacción
window.login = login;


function LANG() {
  return getReportLang();
}


onLangChange(() => {  
  applyLang();             // 🔁 UI general
});




cookiesConsent();
renderLangFlags();
onLangChange(renderLangFlags);

setLang("en")







/* =========================================================
   LANG SELECTOR — BANDERAS
========================================================= */

function renderLangFlags(){

  const root = document.getElementById("langFlags");
  if (!root) return;

  root.innerHTML = "";

  const current = getLangCode();

  getAllLangs().forEach(l => {
    const btn = document.createElement("button");
    btn.className = "langFlag";
    btn.textContent = l.flag;
    btn.title = l.title;

    if (l.code === current) {
      btn.classList.add("active");
    }

    btn.onclick = () => setLang(l.code);

    root.appendChild(btn);
  });
}






 // ==========
    // Enlaces: cambia esta URL por la ruta real de tu simulador 3D
    // ==========
    const enterBtn = document.getElementById("enterBtn");
    const ackCheck = document.getElementById("ackCheck");

    function setEnterEnabled(on){
      enterBtn.disabled = !on;
      enterBtn.style.opacity = on ? "1" : "0.75";
      enterBtn.style.cursor = on ? "pointer" : "not-allowed";
      enterBtn.title = on ? "" : "Debes aceptar el aviso";
    }

    setEnterEnabled(false);

    ackCheck.addEventListener("change", () => {
      setEnterEnabled(!!ackCheck.checked);
    });


    enterBtn.addEventListener("click", () => {
      if (enterBtn.disabled) return;

        openLegalPopup();
      
    });

    // Botón “Entrar al simulador” del hero -> baja al aviso
    document.getElementById("startCta").addEventListener("click", (e) => {
      // permite scroll al #seguridad; no hace nada extra
    });

    // ==========
    // Modal resumen
    // ==========
    const modalBackdrop = document.getElementById("modalBackdrop");
    const closeModalBtn = document.getElementById("closeModalBtn");
    const learnMoreBtn = document.getElementById("learnMoreBtn");

    export function openModal(){
      modalBackdrop.style.display = "flex";
      document.body.style.overflow = "hidden";
    }
    export function closeModal(){
      modalBackdrop.style.display = "none";
      document.body.style.overflow = "";
    }

    learnMoreBtn.addEventListener("click", openModal);
    closeModalBtn.addEventListener("click", closeModal);

    modalBackdrop.addEventListener("click", (e) => {
      if (e.target === modalBackdrop) closeModal();
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });







const menuToggle = document.getElementById("menuToggle");
const navMenu = document.getElementById("navMenu");

menuToggle.addEventListener("click", () => {

  menuToggle.classList.toggle("active");
  navMenu.classList.toggle("open");

});


// cerrar menú al hacer click en un link

navMenu.querySelectorAll("a").forEach(link => {

  link.addEventListener("click", () => {

    navMenu.classList.remove("open");
    menuToggle.classList.remove("active");

  });

});


// OFFSET REAL DEL HEADER
function scrollToAnchor(id) {

  const el = document.querySelector(id);
  if (!el) return;

  const header = document.querySelector(".topbar");

  const headerHeight = header.offsetHeight;

  const y = el.getBoundingClientRect().top + window.scrollY - headerHeight - 10;

  window.scrollTo({
    top: y,
    behavior: "smooth"
  });

}


// INTERCEPTAR TODOS LOS LINKS #
document.querySelectorAll('a[href^="#"]').forEach(link => {

  link.addEventListener("click", function(e){

    const id = this.getAttribute("href");

    if (!id || id === "#") return;

    e.preventDefault();

    scrollToAnchor(id);

  });

});





// ==========================
// SLIDER SYSTEM
// ==========================


// ==========================
// SLIDER SYSTEM (FIXED)
// - Compatible con tu CSS: .slides { display:flex; transform... }
// - Lazy load real (usa atributo src)
// - Preload siguiente
// - Responsive OK (usa offset en px)
// ==========================

const SLIDES = [
{ video: "https://youtube.com/shorts/6AOSOcLBVjA", id: "slide_1", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_loading.png`, caption: "Loading View" },
{ video: "https://youtube.com/shorts/3x8hkPzWi68", id: "slide_2", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_start.png`, caption: "Welcome & Lang Selection" },
{ video: "https://youtube.com/shorts/6AOSOcLBVjA", id: "slide_3", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_data_1.png`, caption: "Start Simulation" },
{  id: "slide_4", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_6.png`, caption: "NDL Limits" },
{  id: "slide_5", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_5.png`, caption: "Deco" },
{  id: "slide_6", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_4.png`, caption: "Deco & Gas Limit" },
{  id: "slide_7", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_3.png`, caption: "Report P1" },
{  id: "slide_8", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_2.png`, caption: "Report P2" },
{  id: "slide_9", img: `https://divantys.com/Views/Default/img/dive_simulator/screenshots/view_1.png`, caption: "eport P3" }

];

const slider = document.getElementById("simSlider");
const track = slider.querySelector(".slides");

function buildSlider() {
  track.innerHTML = "";
  SLIDES.forEach((data, index) => {
    const slide = document.createElement("div");
    slide.className = "slide";
    // Si es el primero, lo marcamos preventivamente
    if(index === 0) slide.classList.add("active");

    slide.innerHTML = `
      <div class="slideInner">
        <img src="${data.img}" loading="lazy" draggable="false">
        <div class="slideCaption">${data.caption}</div>
      </div>
    `;
    
    // Click para ir directamente a esa imagen
    slide.onclick = () => {
        openSlidePopup(data.id, data);
    };

    track.appendChild(slide);
  });
}





document.getElementById("start_video_principal").addEventListener("click", () => {
  console.log("click en imagen principal");
  // aquí llamas tu función
  openSlidePopup("start_video_principal", {
    video: "https://youtube.com/shorts/3x8hkPzWi68",
    img: "https://divantys.com/Views/Default/img/dive_simulator/divantys_video_img.jpg",
    caption: "Intro"
  });
});



// ==========================
// BOTONES (scroll real)
// ==========================

function scrollNext() {
  const slide = track.querySelector(".slide");
  if (!slide) return;

  const width = slide.getBoundingClientRect().width + 16;

  track.scrollBy({ left: width, behavior: "smooth" });
}

function scrollPrev() {
  const slide = track.querySelector(".slide");
  if (!slide) return;

  const width = slide.getBoundingClientRect().width + 16;

  track.scrollBy({ left: -width, behavior: "smooth" });
}

// botones
document.querySelector(".sliderBtn.next")?.addEventListener("click", scrollNext);
document.querySelector(".sliderBtn.prev")?.addEventListener("click", scrollPrev);

// ==========================
// ACTIVE CENTER (efecto PRO)
// ==========================
function updateActive() {

  const slides = [...track.querySelectorAll(".slide")];
  const sliderRect = slider.getBoundingClientRect();

  const trackCenter = sliderRect.left + sliderRect.width / 2;

  let closest = null;
  let minDistance = Infinity;

  slides.forEach(slide => {

    const rect = slide.getBoundingClientRect();
    const slideCenter = rect.left + rect.width / 2;

    const distance = Math.abs(trackCenter - slideCenter);

    if (distance < minDistance) {
      minDistance = distance;
      closest = slide;
    }

  });

  slides.forEach(s => s.classList.remove("active"));
  if (closest) closest.classList.add("active");

}


function centerSlide(index = 0) {
  const slides = track.querySelectorAll(".slide");
  const slide = slides[index];
  if (!slide) return;

  const sliderRect = slider.getBoundingClientRect();
  const slideRect = slide.getBoundingClientRect();

  const offset =
    (slideRect.left - sliderRect.left) -
    (sliderRect.width / 2 - slideRect.width / 2);

  track.scrollBy({ left: offset, behavior: "instant" });
}


track.addEventListener("scroll", () => {
  requestAnimationFrame(updateActive);
});



buildSlider();








export function applyLang() {
  const lang = LANG();
  if (!lang || !lang.index) return;

  const dict = lang.index;

  Object.entries(dict).forEach(([id, text]) => {
    const el = document.getElementById(id);
    if (!el) return;

    // Inputs → placeholder
    if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
      el.placeholder = text;
    }
    // Otros → texto normal
    else {
      el.innerHTML = text;
    }
  });
}


function openSlidePopup(id, data) {

  const popup = document.getElementById("slidePopup");
  const content = document.getElementById("slidePopupContent");

  if (!popup || !content) return;

  let mediaHTML = "";

  // =========================
  // 1. SI HAY VIDEO → iframe
  // =========================
  if (data.video) {

    let videoUrl = data.video.split("?")[0];

    const shortMatch = videoUrl.match(/shorts\/([^/]+)/);
    const normalMatch = videoUrl.match(/v=([^&]+)/);

    if (shortMatch) {
      videoUrl = `https://www.youtube.com/embed/${shortMatch[1]}`;
    } else if (normalMatch) {
      videoUrl = `https://www.youtube.com/embed/${normalMatch[1]}`;
    }

    const isShort = !!shortMatch;
    const ratio = isShort ? "177.77%" : "56.25%";
    const maxWidth = isShort ? "400px" : "100%";

    const separator = videoUrl.includes("?") ? "&" : "?";
    videoUrl += `${separator}autoplay=1&mute=1&playsinline=1`;

    mediaHTML = `
      <div style="position:relative;padding-top:${ratio};max-width:${maxWidth};margin:auto;">
        <iframe
          src="${videoUrl}"
          style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;border-radius:12px;"
          allow="autoplay; encrypted-media"
          allowfullscreen
        ></iframe>
      </div>
    `;

  // =========================
  // 2. SI NO HAY VIDEO → imagen
  // =========================
  } else if (data.img) {

    mediaHTML = `
      <div style="text-align:center;">
        <img 
          src="${data.img}" 
          style="max-width:100%;max-height:80vh;border-radius:12px;"
          draggable="false"
        />
      </div>
    `;
  }

  content.innerHTML = `
    <h3>${data.caption || ""}</h3>
    ${mediaHTML}
  `;

  popup.style.display = "flex";
  document.body.style.overflow = "hidden";
}





function closeSlidePopup(){
  const popup = document.getElementById("slidePopup");
  const content = document.getElementById("slidePopupContent");

  if (!popup) return;

  // 🧨 eliminar iframe completo (100% seguro)
  content.innerHTML = "";

  popup.style.display = "none";
  document.body.style.overflow = "";
}


// 👇 AQUÍ, después de la función
document.getElementById("closeSlideBtn")?.addEventListener("click", closeSlidePopup);

if (closeSlideBtn) {
  closeSlideBtn.addEventListener("click", closeSlidePopup);
}


function T(key){
  const lang = LANG();
  return lang?.index?.[key] || key;
}


// ==========================================
// ⚡ [AÑADIDO] LOGICA DE CONTROL DEL PRELOADER GLOBALES
// ==========================================
function ocultarPreloaderDelSimulador() {
  const preloader = document.getElementById('preloader-global');
  if (preloader) {
    preloader.style.opacity = '0';
    preloader.style.visibility = 'hidden';
    setTimeout(() => preloader.remove(), 500); // Borra el preloader tras la animación
  }
}

// Si las cookies y todos los scripts cargaron antes de que compile este modulo:
if (document.readyState === 'complete') {
  ocultarPreloaderDelSimulador();
} else {
  window.addEventListener('load', ocultarPreloaderDelSimulador);
}